import { Link } from "react-router-dom";
import { Linkedin, Mail, ArrowUpRight } from "lucide-react";

const footerLinks = [
{ href: "/about", label: "About" },
{ href: "/lets-talk-ai", label: "Let's Talk AI" },
{ href: "/blog", label: "Blog" },
{ href: "/contact", label: "Contact" }];


export default function Footer() {
  return (
    <footer className="footer py-16 md:py-24" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        {/* Main CTA */}
        <div className="mb-16">
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl text-white mb-6">
            Let's Connect
          </h2>
          <p className="text-zinc-400 text-lg max-w-xl mb-8">
            If you're exploring AI modernization in customer operations, I'm happy to exchange ideas and perspectives. These are informal, non-commercial discussions focused on learning and insight sharing.
          </p>
          <div className="flex flex-wrap gap-4">
            <a
              href="mailto:contact@vasanthnatarajan.me"
              className="inline-flex items-center hover:bg-zinc-100 transition-colors !font-medium !text-sm gap-2 px-6 py-3 text-zinc-950 bg-white"
              data-testid="footer-email-cta">

              <Mail size={18} />
              contact@vasanthnatarajan.me
              <ArrowUpRight size={16} />
            </a>
            <a
              href="https://www.linkedin.com/in/vasan-natarajan"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 border border-zinc-700 text-white px-6 py-3 text-sm font-medium tracking-wide hover:bg-zinc-800 transition-colors"
              data-testid="footer-linkedin-cta">

              <Linkedin size={18} />
              LinkedIn
              <ArrowUpRight size={16} />
            </a>
          </div>
        </div>

        {/* Links Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-16 pt-16 border-t border-zinc-800">
          <div>
            <h3 className="font-display text-lg text-white mb-4">Navigation</h3>
            <ul className="space-y-2">
              {footerLinks.map((link) =>
              <li key={link.href}>
                  <Link
                  to={link.href}
                  className="text-zinc-400 hover:text-white transition-colors text-sm"
                  data-testid={`footer-link-${link.label.toLowerCase()}`}>

                    {link.label}
                  </Link>
                </li>
              )}
            </ul>
          </div>
          <div>
            <h3 className="font-display text-lg text-white mb-4">Expertise</h3>
            <ul className="space-y-2 text-sm text-zinc-400">
              <li>Agentic AI</li>
              <li>Gen AI Strategy</li>
              <li>Contact Centers</li>
              <li>Voice AI</li>
            </ul>
          </div>
          <div>
            <h3 className="font-display text-lg text-white mb-4">Resources</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/newsletter" className="text-zinc-400 hover:text-white transition-colors text-sm">
                  Newsletter
                </Link>
              </li>
              <li>
                <Link to="/achievements" className="text-zinc-400 hover:text-white transition-colors text-sm">
                  Achievements
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="font-display text-lg text-white mb-4">Legal</h3>
            <ul className="space-y-2 text-sm text-zinc-400">
              <li>Privacy Policy</li>
              <li>Terms of Service</li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="flex flex-col md:flex-row justify-between items-center pt-8 border-t border-zinc-800">
          <p className="text-zinc-500 text-sm mb-4 md:mb-0">
            © {new Date().getFullYear()} Vasanth. All rights reserved.
          </p>
          <p className="text-zinc-600 text-xs">
            Enterprise AI • Agentic Systems • Contact Center Modernization
          </p>
        </div>
      </div>
    </footer>);

}